//---------------------------------------------------------------//
// Toggle the User's Sub Menu Dropdown
//---------------------------------------------------------------//

// variables first
const menuBreakpoint = 1000;
const userMenuContainer = $('.top-bar-actions .user-details');
const userMenuTrigger = $('.top-bar-actions .user-details > a');
const userMenu = $('.top-bar-actions .user-details-sub-menu');

let userMenuOpen = false;

function toggleUserMenu() {
  userMenuTrigger.off('click'); // Prevent duplicate bindings
  userMenuContainer.unbind('mouseenter mouseleave'); // Prevent duplicate bindings

  if (window.innerWidth < menuBreakpoint) {
    userMenu.css('display', 'block');
  } else {
    // Otherwise, handle the hover effect for desktop users
    // first, remove the display:block; that is added in when on mobile
    userMenu.removeAttr('style');

    // Jobin 2019-02-18: removed this bit favor of moving the user details menu into the main menu for mobile
    // Handle the touch/click effect for tablet/mobile users
    if (!userMenuContainer.hasClass('guest')) {
      userMenuTrigger.on('click', function (e) {
        e.preventDefault();
        if (!userMenuOpen) {
          userMenu.slideDown(300);
          userMenuOpen = true;
        } else {
          userMenu.slideUp(300);
          userMenuOpen = false;
        }
      });
    }

    // handle the show/hide based on hover now
    userMenuContainer.hover(function () {
      userMenu.stop('fx', true).slideToggle(300);
    });
  }
}

// Run the function immediately and then again after window resize
toggleUserMenu();
$(window).resize(toggleUserMenu);
